import React from 'react'
import MDBox from "components/MDBox";
import { LanguageContext } from "App";
import { useContext } from 'react';
const SwitchTabButtons = ({setTabSwitcher}) => {
    const {translations} = useContext(LanguageContext)
    return (

        <MDBox mb={2} pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
            <button className='btn btn-outline-dark' onClick={() => setTabSwitcher("SingleSessions")}>
                {translations.SingleSessions}</button>
            <button className='btn btn-outline-dark' onClick={() => setTabSwitcher("Packages")}>
                {translations.Packages}</button>
            {/* <button className='btn btn-outline-dark' onClick={() => setTabSwitcher("PackageGroups")}>
                Package Groups</button> */}
        </MDBox>

    )
}

export default SwitchTabButtons